import React, { ReactNode } from 'react';
import Image from 'next/image';
import { DialogClose, DialogTitle } from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';

import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@/src/components/ui/dialog';
import { IResolvedCountry } from '@/src/utils/country';
import { replaceDynamicVariable } from '@/src/utils/format/node';

type IProps = {
  countries?: IResolvedCountry[];
  titleDialog: ReactNode;
  listCountryText: string | null;
};

export const DestinationDetailsListCountries = ({
  countries = [],
  titleDialog,
  listCountryText,
}: IProps) => {
  return (
    <>
      {countries.length > 1 && (
        <Dialog>
          <DialogTrigger>
            <div
              className={
                'flex items-center gap-1 rounded-lg bg-neutral-100 px-3 py-1 hover:bg-neutral-200 active:bg-neutral-300'
              }
            >
              <div className={'flex items-center pl-[12px]'}>
                {countries
                  ?.slice(0, 3)
                  .map(country => (
                    <Image
                      key={country.label}
                      src={`/static/flags/${country.flagName}`}
                      alt={country.label}
                      width={24}
                      height={24}
                      className={'ml-[-12px]'}
                    />
                  ))}
              </div>
              <p className={'font-semibold text-gray'}>
                {listCountryText} ({countries.length})
              </p>
              <Image
                src={'/static/icons/chevron-down.svg'}
                alt=""
                width={10}
                height={7}
                className={'ml-2 mt-1'}
              />
            </div>
          </DialogTrigger>
          <DialogTitle
            title={replaceDynamicVariable(
              titleDialog,
              '$country',
              countries.length.toString()
            )}
          />
          <DialogContent
            className={
              'no-scrollbar flex max-h-[460px] min-h-[300px] flex-col overflow-y-scroll p-0'
            }
          >
            <DialogClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
              <Cross2Icon className="size-4" />
              <span className="sr-only">Close</span>
            </DialogClose>
            <div className={'h-auto px-8 pb-2 pt-4 text-3xl font-semibold'}>
              {replaceDynamicVariable(
                titleDialog,
                '$country',
                countries.length.toString()
              )}
            </div>
            <div className={'space-y-4 px-8'}>
              {countries.map(country => (
                <div key={country.label} className={'flex items-center gap-3'}>
                  <Image
                    src={`/static/flags/${country.flagName}`}
                    alt={country.label}
                    width={24}
                    height={24}
                  />
                  <p className={'font-semibold'}>{country.label}</p>
                </div>
              ))}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
